import { useState } from "react";
import Page from "src/components/Report/Page";
import HeaderFactors from "./components/Factors/HeaderFactors";
import ExplainFactor from "./components/Factors/ExplainFactor";
import SpaceBetweenTables from "./components/Factors/SpaceBetweenTables";
import Table4 from "./components/Factors/Table/Table4";
import Table11 from "./components/Factors/Table/Table11";
import Table5 from "./components/Factors/Table/Table5";

const PageG2 = ({ reload }) => {
    const [masouliatScore, setMasouliatScore] = useState("")
    const [sarparastiMostagin, setSarparastiMostagin] = useState("")
    const [sarparastiGheirMostagin, setSarparastiGheirMostagin] = useState("")
    return (
        <>
            <Page pageNumber={26}>
                <HeaderFactors
                    numberFactors="عامل چهارم"
                    titelFactors="منابع انسانی (سرپرستی)"
                    maxValue="40"
                    jsValue={+sarparastiMostagin + +sarparastiGheirMostagin}
                />
                <ExplainFactor
                    text="این عامل به مسئولیت در قبال منابع انسانی تحت نظر بوده وعبارت است از توانمندسازی، برنامه ریزی،
                    هدفگذاری، سازماندهی نظارت ومربی گری افراد تحت سرپرستی به منظور انجام صحیح امور محوله می
                    باشد."
                />
                <Table4 sarparastiMostagin={sarparastiMostagin}
                    setSarparastiMostagin={setSarparastiMostagin} reload={reload}/>
                <Table11 sarparastiGheirMostagin={sarparastiGheirMostagin}
                    setSarparastiGheirMostagin={setSarparastiGheirMostagin} reload={reload}/>
                <SpaceBetweenTables />
                <HeaderFactors
                    numberFactors="عامل پنجم"
                    titelFactors="مسئوليت منابع فيزیكی"
                    maxValue="30"
                    jsValue={masouliatScore}
                />
                <ExplainFactor
                    text="منابع فیزیکی شامل مواد، محصولات، ماشین آلات، تجهیزات، ابزارها و سخت افزارها و نرم افزارها می‌باشد"
                />
                <Table5 masouliatScore={masouliatScore} setMasouliatScore={setMasouliatScore} reload={reload}/>
            </Page>
        </>
    );
};

export default PageG2;
